<template>
    <b-container class="pl-0 pr-0">
        <b-col lg="12" class="no-gutters">
        <b-row>
            <campaign-item
                v-for="campaign in visibleResults"
                :key="campaign.id"
                :campaign="campaign"
                :show-donate="showDonate"
                @onLoaded="addVisibleResults"
                @onClicked="showCampaign"
                @donate="donate"/>
        </b-row>
        <b-row v-if="!loading && (!results || results.length < 1)">
            <span  class="col-12 no-results pt-1 pb-3">
                    {{ $t('campaign.no_campaigns') }}
            </span>
        </b-row>
        <b-modal
                v-if="selectedCampaign"
                v-model="showModal"
                id="modal-tall"
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
                centered
                :title="$t('payment.make_donation')"
                @close="hideModal"
                size="lg">
            <payment
                    :campaign-id="selectedCampaign.id"/>
        </b-modal>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </b-col>
    </b-container>
</template>

<script>
    import FairApi from "../../modules/api";
    import CampaignItem from "../campaign/CampaignItem";
    import Payment from "../payment/Payment"

    export default {
        name: "campaign-feed",
        components: {Payment, CampaignItem},
        props: {
            category: {
                type: Number,
                default: 0
            },
            campaigns: {
                type: Array,
                default() {
                    return null
                }
            },
            showDonate: {
                type: Boolean,
                default: true
            },
            teamId: {
                type: Number,
                default: null
            },
            organizationId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                results: [],
                visibleResults: [],
                showModal: false,
                selectedCampaign: null,
                loading: false,
                busy: false
            }
        },

        watch: {
            organizationId: function () {
                if (this.organizationId !== null)
                this.fetchCampaigns()
            },
            teamId: function () {
                if (this.teamId !== null)
                    this.fetchCampaigns()
            },
            category: function () {
                if (this.category && this.category > 0)
                    this.fetchCampaigns()
            },
            campaigns: function () {
                if (this.campaigns !== null) {
                    this.results = this.campaigns
                    this.visibleResults = []
                    this.addVisibleResults()
                }
            },
            selectedCampaign: function () {
                this.showModal = !!this.selectedCampaign
            }
        },

        created: function() {
            if (this.campaigns !== null) {
                this.results = this.campaigns
            }

            if (this.teamId !== null || (this.category && this.category > 0)) {
                this.fetchCampaigns()
            }
        },

        methods: {
            fetchCampaigns: function () {
                this.loading = true
                this.visibleResults = []
                // get active and open campaigns
                let param = {open: true}

                if (this.category && this.category > 0) {
                    param.category = this.category
                }

                if (this.organizationId !== null) {
                    param.organization = this.organizationId;
                }

                if (this.teamId !== null) {
                    param.team = this.teamId;
                }

                FairApi.getWithParams(FairApi.campaign(), param,
                    this.success, this.failed)
            },

            success: function (response) {
                this.results = response
                    //.filter(function (item) {
                    // if (item.organization.stripe_id) {
                //     return true
                // }
                // return false
                //  })
                this.addVisibleResults()
                this.loading = false
            },

            failed: function () {
                this.loading = false
            },

            donate(campaign) {
                this.selectedCampaign = campaign
            },

            showCampaign(campaign) {
                this.$router.push({name: 'campaign-info-view', params: {id: campaign.id}})
            },

            hideModal() {
                this.selectedCampaign = null
            },

            loadMore() {
                this.busy = true
                this.addVisibleResults()
                this.busy = false
            },

            addVisibleResults() {
                if (this.visibleResults.length < this.results.length) {
                    this.visibleResults.push(this.results[this.visibleResults.length])
                }
            }

        }
    }
</script>

<style scoped>

</style>
